/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{useIsoMorphicEffect as o}from"../use-iso-morphic-effect.js";import{useStore as e}from"../use-store.js";import{overflows as r}from"./overflow-store.js";function s(s,t,f){let c=e(r),i=s?c.get(s):void 0,u=!!i&&i.count>0;return o((()=>{if(s&&t)return r.dispatch("PUSH",s,f),()=>r.dispatch("POP",s,f)}),[t,s]),u}export{s as useDocumentOverflowLockedEffect};
//# sourceMappingURL=use-document-overflow.js.map
